<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="municipios" titulo="Municipio / Catalogos" [dato]="dato" ></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside ></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()" >
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                <a id="catalogos" (click)="ctrl.cargarCatalogo('paises', 'paises'); ctrl.cargarCatalogo('estados', 'estados', 'recargar');"></a>
                <section class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">

                    <div class="field">
                        <label class="label">Clave:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('clave').hasError('required') && ctrl.dato.get('clave').hasError('required')}"
                                placeholder="Clave" formControlName="clave">
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('clave').hasError('required') && ctrl.dato.get('clave').hasError('required')">
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.get('clave').hasError('required') && ctrl.dato.get('clave').hasError('required')">Este campo es requerido.</span>
                        </p>
                    </div>

                    <div class="field">
                        <label class="label">Nombre:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }"
                                placeholder="Nombre" formControlName="nombre">
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                        </p>
                    </div>

                    <div class="field">
                        <label class="label">País:</label>
                        <ng-select2 [disabled]="ctrl.paises ? ctrl.paises.length == 0 ? true : false : true" name="paises_id" [options]="ctrl.optionSelect"  [value]="ctrl.dato.controls.paises_id.value"
                        (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.paises_id, 'estados', 'estados');"
                            [data]="ctrl.paises"></ng-select2>
                    </div>

                    <div class="field">
                        <label class="label">Estado:</label>
                        <ng-select2 [disabled]="ctrl.estados ? ctrl.estados.length == 0 ? true : false : true" name="estados_id" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.estados_id.value"
                        (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.estados_id);"
                            [data]="ctrl.estados"></ng-select2>
                    </div>

                </section>
            </form>
        </div>
    </div>
</div>
